// @flow

// prettier-ignore

export default {

  Accept: 'Menerima',
  AcceptRegistration: 'Terima pendaftaran',
  AcceptTermsOfAccess_SentenceCase: 'Terima persyaratan akses',
  Access: 'Mengakses',
  AccessAllowed: 'Akses diizinkan',
  AccessDenied: 'Akses ditolak',
  AccessedAgo: 'Diakses [time] lalu',
  Actions: 'Tindakan',
  Add: 'Menambahkan',
  AddAndInvite: 'Tambahkan dan undang',
  AddAndInvitePeople: 'Tambahkan dan undang orang',
  AdditionalRecipients: 'Penerima tambahan',
  AdditionalRecipients_SentenceCase: 'Penerima tambahan',
  AdditionalRecipientsHint: 'Masukkan setiap alamat email pada baris terpisah',
  AddPeople: 'Tambahkan orang',
  AddPeopleTo: 'Tambahkan orang ke',
  AddPeopleToSubteam: 'Tambahkan orang ke [Team]/[Subteam]',
  AddPeopleToTeam: 'Tambahkan orang ke [Team]',
  AddPeopleWillHaveTheSameAccess: 'Orang yang ditambahkan akan memiliki akses yang sama',
  AddToExistingTeam: 'Tambahkan ke tim yang ada',
  Administration: 'Administrasi',
  AdminSideAudit: 'Tim',
  AdminSideBankruptcy: 'Sisi Jual',
  AdminSideBankruptcy_EmailHeading: 'Email orang yang menjual',
  AdminSideBankruptcy_InviteHeading: 'Kirim undangan untuk menjual orang sampingan',
  AdminSideDebt: 'Penerbit',
  AdminSideDebt_EmailHeading: 'Penerbit email',
  AdminSideDebt_InviteHeading: 'Kirim undangan ke penerbit',
  AdminSideDocumentRepository: 'Intern',
  AdminSideDocumentRepository_EmailHeading: 'Email internal',
  AdminSideDocumentRepository_InviteHeading: 'Kirim undangan ke internal',
  AdminSideFundraising: 'Klien',
  AdminSideFundraising_EmailHeading: 'Klien email',
  AdminSideFundraising_InviteHeading: 'Kirim undangan ke klien',
  AdminSideInternalAudit: 'Tim',
  AdminSideJointVenture: 'Intern',
  AdminSideJointVenture_EmailHeading: 'Email internal',
  AdminSideJointVenture_InviteHeading: 'Kirim undangan ke internal',
  AdminSideMerger: 'Sisi penjualan',
  AdminSideMerger_EmailHeading: 'Email orang yang menjual',
  AdminSideMerger_InviteHeading: 'Kirim undangan untuk menjual orang sampingan',
  AdminSideOther: 'Intern',
  AdminSideOther_EmailHeading: 'Email internal',
  AdminSideOther_InviteHeading: 'Kirim undangan ke internal',
  AdminSidePlacement: 'Penerbit',
  AdminSidePlacement_EmailHeading: 'Penerbit email',
  AdminSidePlacement_InviteHeading: 'Kirim undangan ke penerbit',
  AdminSidePublicOffer: 'Intern',
  AdminSidePublicOffer_EmailHeading: 'Email internal',
  AdminSidePublicOffer_InviteHeading: 'Kirim undangan ke internal',
  AdminSideTargeted: 'Tim internal',
  AdminSideTargeted_EmailHeading: 'Email tim internal',
  AdminSideTargeted_InviteHeading: 'Kirim undangan ke tim internal',
  AdminSideTax: 'Tim',
  AdminSideTender: 'Klien',
  AdminSideTender_EmailHeading: 'Klien email',
  AdminSideTender_InviteHeading: 'Kirim undangan ke klien',
  All: 'Semua',
  Allow: 'Mengizinkan',
  Allowed: 'Diizinkan',
  AlwaysInviteGuestDialogContent:
    'Anda perlu menghubungi Ansarada untuk mengubah rencana. Jangan khawatir, Anda akan segera mengirimkan undangan ke pihak luar.',
  And_SentenceCase: 'Dan',
  AndGoLive: 'dan tayang langsung',
  AreYourReadyToGoLive: 'Apakah Anda siap untuk melakukan siaran langsung?',
  AreYouSureToDeclineRegistration: 'Apakah Anda yakin ingin menolak pendaftar [registrant]?',
  AreYouSureToDeleteRegistration: 'Apakah Anda yakin ingin menghapus pendaftar [registrant]?',
  AreYouSureToDeleteRequest: 'Apakah Anda yakin ingin menghapus permintaan [registrant]?',
  At: 'Pada',
  Attachments: 'Lampiran',
  BackToTeamsPage: 'Kembali ke halaman tim',
  BannerMessage: "Tim dibuat dengan pengaturan [TeamName]",
  BatchOperationCantBePerformed:
    'Operasi batch tidak dapat dilakukan karena tidak ada Pengguna di Ruang Data ini. Harap masukkan Pengguna terlebih dahulu.',
  BeforeYouCanEmail:'Sebelum Anda dapat mengirim email [teamType], Anda perlu memverifikasi email Anda.',
  BeforeYouCanGoLive: 'Sebelum Anda dapat melakukan siaran langsung',
  BeforeYouCanSendInvites:'Sebelum Anda dapat mengirim undangan ke [teamType], Anda perlu memverifikasi email Anda.',
  BillingCommencesWhenTheFirstGuestIsInvited:'Penagihan dimulai saat tamu pertama diundang.',
  BulkDownload_SentenceCase: 'Unduhan massal',
  BulkDownloadText:
    'Memungkinkan orang mengunduh beberapa file dalam satu file .zip. Unduhan zip hanya tersedia untuk waktu terbatas.',
  BuySide: 'Sisi Beli',
  BuySide_InviteHeading: 'Kirim undangan untuk membeli orang sampingan',
  BuySide_SentenceCase: 'Sisi Beli',
  BySubmittingThisForm: 'Dengan mengirimkan formulir ini, Anda menyetujui ketentuan kami',
  Cancel: 'Membatalkan',
  Change: 'Mengubah',
  ChangeTeamAccess: 'Ubah Akses Tim',
  ChooseLanguage: 'Pilih bahasa',
  ClickAndPreview: '2. Klik dan pratinjau',
  Close: 'Menutup',
  CollapseAll_SentenceCase: 'Tutup semua',
  Colour: 'Warna',
  Company: 'Perusahaan',
  Confirm: 'Mengonfirmasi',
  ContactUs: 'Hubungi kami',
  Copied: 'Disalin',
  CopiedSharedLinkInfo: 'Bagikan tautan dengan tim penawar eksternal atau tamu sehingga mereka dapat mendaftar.',
  CopyEmailsOfSelectedUsers: 'Salin email pengguna yang dipilih',
  CopyEmailsOfSelectedUsersSec2: 'Salin email yang dipilih',
  CopyingAllowed: 'Menyalin diizinkan',
  CopyingDenied: 'Penyalinan ditolak',
  CopyingSecuritySettings: 'Menyalin pengaturan keamanan',
  CopyLink: 'Salin Tautan',
  CopyOf: 'Salinan dari',
  CopyRegistrationLink: 'Salin tautan pendaftaran',
  CopySecurity: 'Salin keamanan',
  CopySharedLinkToClipboard: 'Salin Tautan ke papan klip',
  CopyTeam: 'Salin tim',
  CreateArchive: 'Buat arsip',
  CreateNewTeam: 'Buat tim baru',
  CreatePeopleWithSameEmail: 'Buat orang yang memiliki email yang sama dengan orang yang sudah ada',
  CreateSideTeam: 'Buat tim [Side]',
  CreateSubteam: 'Buat sub-tim',
  CreateTeam: 'Buat tim',
  CreateTeamEmptyState: 'Buat tim untuk mengatur orang dan mengatur akses',
  CreateWatermark: 'Buat watermark',
  Daily: 'Sehari-hari',
  DataRoom: 'Ruang data',
  DataroomRole: 'Peran ruangan',
  DataRooms: 'Ruang data',
  DataRoomStatus: 'Status ruang data',
  DataRoomUserNotVerified1: 'Untuk mengakses ruang data:',
  DataRoomUserNotVerified2: 'Buka email undangan Anda',
  DataRoomUserNotVerified3: 'Klik tautan "Verifikasi detail Anda"',
  DataRoomUserNotVerified4: 'Masuk',
  DataRoomUserNotVerified5:
    "Jika Anda belum menerima email undangan, silakan hubungi administrator ruang data Anda.",
  DataRoomUserNotVerifiedTitle: "Akses Anda belum diverifikasi",
  DateModified: 'Tanggal modifikasi',
  DateSent: 'Tanggal pengiriman',
  Decline: 'Menolak',
  Declined: 'Ditolak',
  DeclineRegistration: 'Tolak pendaftaran',
  Delete: 'Menghapus',
  DeleteBidderInformation:
    "Tim hanya dapat dihapus jika tim tersebut bukan penawar yang memenuhi syarat dalam proses Evaluasi. Hapus tim ini dari daftar penawar yang memenuhi syarat.",
  DeleteBidderTeamInformationLine1:
    "Suatu tim hanya dapat dihapus apabila tim tersebut kosong dan bukan merupakan penawar yang memenuhi syarat dalam proses Evaluasi.",
  DeleteBidderTeamInformationLine2:
    'Pindahkan orang dari tim ini dan hapus tim ini dari daftar penawar yang memenuhi syarat.',
  DeletePerson: 'Hapus orang',
  DeletePersonConfirm: 'Hapus orang',
  DeletePersonHeader: 'Hapus [email]?',
  DeletePersonMessage:
    'Menghapus [email] akan menghapusnya secara permanen dari Ruang, semua laporan aktivitas, dan riwayat. Tindakan ini tidak dapat dibatalkan.',
  DeleteRegistration: 'Hapus registrasi',
  DeleteRequest: 'Hapus permintaan',
  DeleteSubteam: 'Hapus sub-tim',
  DeleteSubteamInformation:
    'Sub-tim hanya dapat dihapus jika kosong. Pindahkan orang dari sub-tim ini untuk menghapusnya.',
  DeleteTeam: 'Hapus tim',
  DeleteTeamInformation:
    'Tim hanya dapat dihapus jika kosong. Pindahkan orang dari tim ini untuk menghapusnya.',
  DeletingTeamContainsPeople:
    'Tim hanya dapat dihapus jika kosong. Pindahkan orang dari tim ini untuk menghapusnya.',
  DemoAllCaps: 'PERTUNJUKAN',
  Deny: 'Membantah',
  DenyCopyingDisabled: 'Penolakan penyalinan dinonaktifkan',
  DenyEditingDisabled: 'Tolak penyuntingan dinonaktifkan',
  DenyPrintingDisabled: 'Penolakan pencetakan dinonaktifkan',
  DenySavingDisabled: 'Tolak penyimpanan dinonaktifkan',
  DidntReceiveTheEmail: "Tidak menerima email?",
  Disable: 'Cacat',
  DisableAccess: 'Nonaktifkan akses',
  Disabled: 'Dengan disabilitas',
  DisabledUser: 'Pengguna yang dinonaktifkan',
  DisableRegistrations: 'Nonaktifkan Registrasi',
  DisableRegistrations_SentenceCase: 'Nonaktifkan registrasi',
  DisableRegistrationsAction: 'Cacat',
  DisableRegistrationsInformation: 'Jika dinonaktifkan, tautan pendaftaran tidak lagi aktif.',
  Disallowed: 'Tidak diizinkan',
  Document: 'Dokumen',
  DocumentIndex: 'Indeks dokumen',
  DocumentIndexSecurity: 'Keamanan Indeks Dokumen',
  Documents: 'Dokumen',
  Down: 'Turun',
  Draft: 'Draf',
  Edit: 'Sunting',
  EditAfterCloseDate: 'Edit indeks pengiriman setelah tanggal penutupan',
  EditDocumentSecurityTeam:
    'Tidak ada kontrol keamanan cetak atau simpan, akses atau tanda air yang ditetapkan untuk tim ini.',
  EditDocumentSecurityTeamSubteam:
    'Tidak ada kontrol keamanan cetak atau simpan, akses atau tanda air yang ditetapkan untuk sub-tim ini.',
  EditingAllowed: 'Mengedit diperbolehkan',
  EditingDenied: 'Pengeditan ditolak',
  EditMultipleUsers: 'Edit Beberapa Pengguna',
  EditPeople: 'Edit orang',
  EditPerson: 'Edit orang',
  EditPersonFormInvitationMessage:
    'Kirim undangan baru ke alamat email yang diperbarui dengan mengklik kotak centang di bawah ini',
  EditProfile: 'Edit profil',
  EditSecurity_SentenceCase: 'Edit keamanan',
  EditSecurityFor: 'Edit keamanan untuk',
  EditSubteam: 'Edit sub-tim',
  EditTeam: 'Edit tim',
  Email: 'E-mail',
  EmailAddress: 'alamat email',
  EmailCanNotBeEmpty: 'Email tidak boleh kosong',
  EmailHasBeenSent: 'Email telah terkirim.',
  EmailMessage: 'Pesan email adalah bidang yang wajib diisi',
  EmailNotifications: 'Pemberitahuan email',
  EmailNotValid: 'Email tidak valid',
  EmailPeople: 'Kirim email ke orang',
  EmailPeopleSubjectRequiredSentenceCase: 'Subjek diperlukan untuk email',
  Emails: 'Surel',
  EmailsNotValid: 'Email [Email] tidak valid',
  EmailSuccessMessage: 'Email Anda telah berhasil dikirim.',
  EnableAccess: 'Aktifkan akses',
  Enabled: 'Diaktifkan',
  EnableRegistrations: 'Aktifkan Registrasi',
  EnableRegistrations_SentenceCase: 'Aktifkan registrasi',
  EnableRegistrationsAction: 'Memungkinkan',
  EnableRegistrationsInformation:
    'Bila diaktifkan, tautan pendaftaran aktif dan dapat dibagikan secara publik.',
  EnterIpAddressesRanges: 'Masukkan alamat IP atau rentang alamat IP yang dipisahkan dengan tombol Enter',
  EnterOneOrMoreEmailAddresses: 'Email untuk setiap orang',
  EnterYourLocationOrClosestCity: 'Masukkan lokasi Anda atau kota terdekat',
  Every: 'Setiap',
  ExpandAll_SentenceCase: 'Perluas semua',
  ExportToExcel_SentenceCase: 'Ekspor ke Excel',
  FieldIsRequired: '[field] diperlukan',
  FieldMustBeAtMostMaxCharacters: '[field] maksimal harus berisi karakter [max].',
  FileExtensionIsInList:
    'File "[FileName]" tidak dapat diunggah, karena ekstensinya ada dalam daftar ekstensi file yang tidak diizinkan untuk ruang data ini:\n\n[FileTypeList]\n\nHarap ubah file ini ke salah satu format yang diizinkan.',
  FileExtensionIsNotInList:
    'File "[FileName]" tidak dapat diunggah, karena ekstensinya tidak ada dalam daftar ekstensi file yang diizinkan untuk ruang data ini:\n\n[FileTypeList]\n\nHarap ubah file ini ke salah satu format yang diizinkan.',
  Filter: 'Menyaring',
  FirstName: 'Nama depan',
  Folder: 'Map',
  ForRangesSeparateStartIp:
    'Untuk rentang, pisahkan IP awal dan IP akhir dengan tanda hubung, misalnya <b>1.1.1.1-1.1.1.6</b>',
  Friday: 'Jumat',
  From: 'Dari:',
  FullName: 'Nama lengkap',
  FullText: 'Pencarian teks lengkap',
  FullTextText: 'Izinkan orang untuk mencari dalam dokumen.',
  GDPRInformation: 'Informasi GDPR',
  GlobalUnexpectedErrorMessage:
    "Ada masalah dengan ruang data Anda. Silakan hubungi tim Layanan Klien kami.",
  GlobalUnexpectedErrorWithIdMessage:
    "Ada masalah dengan ruang data Anda. Kutip kode ini<[ErrorId]> ke tim Layanan Klien kami.",
  GoLiveDialogTitle: 'Tayang langsung',
  GotIt: 'Mengerti',
  Guest: 'Tamu',
  GuestUserRegistration: 'Registrasi pengguna tamu',
  GuideToUsingLink: 'Panduan penggunaan Link',
  Help: 'Membantu',
  HelpAndSupport: 'Bantuan & dukungan',
  HideMenu: 'Sembunyikan menu',
  High: 'Tinggi',
  History: 'Sejarah',
  Hourly: 'Per jam',
  IamNotReadyYet: 'Belum',
  ID: 'PENGENAL',
  Importance: 'Pentingnya',
  Important:'PENTING!',
  Information: 'Informasi',
  Interval: 'Selang',
  InvalidEmailAddress: 'Alamat email tidak valid',
  InvalidField: '[field] tidak valid',
  InvalidPdf: 'ERROR: Berkas ini bukan dokumen pdf yang valid. Silakan coba berkas lain.',
  Invitation: 'Undangan',
  InvitationEmail: 'Email undangan',
  InvitationSuccessMessage: 'Undangan Anda telah berhasil dikirim.',
  Invite: 'Mengundang',
  InviteAGuest: 'Undang tamu',
  Invited: 'Diundang',
  Invited_Users_: 'Diundang',
  InvitePeople: 'Undang Orang',
  IpAccessList: 'Daftar Akses IP',
  IpAccessList_SentenceCase: 'Daftar akses IP',
  IpAccessListCanNotBeEmpty: 'Daftar akses IP tidak boleh kosong',
  IpAddressInvalidIpAccessList: "IP '[IpAddress]' dalam Daftar Akses IP bukan alamat IP yang valid.",
  IpAddressInvalidRangeIpAccessList:
    "Rentang IP '[IpRange]' dalam Daftar Akses IP memiliki alamat IP awal yang lebih besar daripada alamat IP akhir. IP awal harus lebih kecil atau sama dengan IP akhir.",
  IpLimitRangeIpAccessList:
    "Harap batasi deskripsi rentang IP '[IpRange]' dalam Daftar Akses IP ke karakter [NumOfChars]. Anda menggunakan karakter [UsedNumOfChars].",
  IpUserAccessListLimit:
    'Harap batasi Daftar Akses IP ke karakter [MaxNumberOfCharacters]. Anda memasukkan karakter [EnteredNumberOfCharacters].',
  IWillInviteLater:"Aku akan mengundang nanti",
  JobTitle: 'Judul pekerjaan',
  JobTitleProfession: 'Jabatan/profesi',
  Last30days: '30 hari terakhir',
  Last7days: '7 hari terakhir',
  LastMonth: 'Bulan lalu',
  LastName: 'Nama belakang',
  LastWeek: 'Minggu lalu',
  LearnMore: 'Pelajari lebih lanjut',
  LicenceChatHelp: 'Ngobrol dengan spesialis.',
  LicenceErrorHelp: 'Butuh Bantuan? ',
  LicenceErrorMessage:
    'Lisensi Anda habis. Langganan Anda akan ditingkatkan jika melebihi batas.',
  LicencePack: 'Paket prabayar tim pengguna',
  LicencePrompt:
    'Anda mungkin memiliki undangan yang tertunda, lisensi hanya akan digunakan setelah undangan diterima. Langganan Anda akan ditingkatkan jika Anda melampaui batas.',
  LicenceSectionPlan: 'Rencana Anda',
  LicenceTooltip: 'Lisensi dikonsumsi ketika seseorang ada di platform dengan cara berikut:',
  LicenceTooltipStep1: 'Hanya di Platform Pathways',
  LicenceTooltipStep2: 'Hanya di Platform Data Room',
  LicenceTooltipStep3: 'Keduanya',
  LicenseMessage:
    'Undangan yang diterima akan menggunakan lisensi dari langganan Anda. Langganan Anda akan ditingkatkan jika melebihi batas.',
  LimitedCharacterLength: '[1] tidak boleh melebihi karakter [0].',
  LinkCopied: 'Tautan disalin',
  LinkCopiedToClipboard: 'Tautan disalin ke papan klip',
  LinkedDocuments: 'Dokumen terkait',
  Loading: 'Memuat',
  LoadingThreeDots: 'Memuat...',
  Location: 'Lokasi',
  LoggedInToDate_SentenceCase: 'Telah masuk hingga saat ini',
  LoginIpAccess: 'Akses IP masuk',
  LoginLowerCase: 'login',
  LoginsLowerCase: 'masuk',
  Logout: 'Keluar',
  Low: 'Rendah',
  Manage: 'Mengelola',
  ManageQnaSubjects: 'Kelola subjek Q&A',
  Medium: 'Sedang',
  Message: 'Pesan',
  MessageEmpty: 'Pesan tidak boleh kosong',
  Minute: 'menit',
  Minutes: 'menit',
  ModifiedAgo: 'Diubah [time] lalu',
  ModifiedBy: 'Dimodifikasi oleh',
  Monday: 'Senin',
  MyAccount: 'Akun saya',
  Name: 'Nama',
  NavigateAwayConfirm: 'Meninggalkan',
  NavigateAwayWarning: 'Tinggalkan halaman?',
  NavigateAwayWarningMessage: 'Perubahan yang Anda buat tidak akan disimpan.',
  Never: 'Tidak pernah',
  NeverLoggedIn_SentenceCase: 'Belum pernah login',
  No: 'TIDAK',
  NoCompanyContact: 'Tidak ada kontak perusahaan',
  NoDemonstration: 'Tidak ada demonstrasi',
  NonAdminSideBankruptcy: 'Sisi Beli',
  NonAdminSideBankruptcy_EmailHeading: 'Email orang yang membeli di sisi',
  NonAdminSideBankruptcy_InviteHeading: 'Kirim undangan untuk membeli orang sampingan',
  NonAdminSideDebt: 'Investor',
  NonAdminSideDebt_EmailHeading: 'Email investor',
  NonAdminSideDebt_InviteHeading: 'Kirim undangan ke investor',
  NonAdminSideDocumentRepository: 'Luar',
  NonAdminSideDocumentRepository_EmailHeading: 'Email eksternal',
  NonAdminSideDocumentRepository_InviteHeading: 'Kirim undangan ke pihak eksternal',
  NonAdminSideFundraising: 'Pemodal',
  NonAdminSideFundraising_EmailHeading: 'Email pemodal',
  NonAdminSideFundraising_InviteHeading: 'Kirim undangan ke pemodal',
  NonAdminSideJointVenture: 'Luar',
  NonAdminSideJointVenture_EmailHeading: 'Email eksternal',
  NonAdminSideJointVenture_InviteHeading: 'Kirim undangan ke pihak eksternal',
  NonAdminSideMerger: 'Sisi beli',
  NonAdminSideMerger_EmailHeading: 'Email orang yang membeli di sisi',
  NonAdminSideMerger_InviteHeading: 'Kirim undangan untuk membeli orang sampingan',
  NonAdminSideOther: 'Luar',
  NonAdminSideOther_EmailHeading: 'Email eksternal',
  NonAdminSideOther_InviteHeading: 'Kirim undangan ke pihak eksternal',
  NonAdminSidePlacement: 'Investor',
  NonAdminSidePlacement_EmailHeading: 'Email investor',
  NonAdminSidePlacement_InviteHeading: 'Kirim undangan ke investor',
  NonAdminSidePublicOffer: 'Luar',
  NonAdminSidePublicOffer_EmailHeading: 'Email eksternal',
  NonAdminSidePublicOffer_InviteHeading: 'Kirim undangan ke pihak eksternal',
  NonAdminSideTargeted: 'Tim sasaran',
  NonAdminSideTargeted_EmailHeading: 'Email target tim',
  NonAdminSideTargeted_InviteHeading: 'Kirim undangan ke tim target',
  NonAdminSideTender: 'Penawar',
  NonAdminSideTender_EmailHeading: 'Kirim email ke penawar',
  NonAdminSideTender_InviteHeading: 'Kirim undangan ke penawar',
  None: 'Tidak ada',
  NoQuestionPermission: "Anda tidak memiliki izin untuk menetapkan subjek pertanyaan.",
  NoQuestionSubjects: "Anda belum memiliki subjek pertanyaan.",
  NoRecordsFound: 'Tidak ada catatan yang ditemukan.',
  Normal: 'Normal',
  NoRooms: "Saat ini Anda tidak memiliki Kamar",
  NoRoomsMatch: 'Tidak ada Kamar yang ditemukan',
  NoScorecards: "Saat ini Anda tidak memiliki Kartu Skor apa pun",
  NoScorecardsMatch: 'Tidak ada Kartu Skor yang ditemukan',
  Notes: 'Catatan',
  Notifications: 'Pemberitahuan',
  NotInvited: 'Tidak diundang',
  NotInvited_Users__SentenceCase: 'Tidak diundang',
  NotVerified_Users__SentenceCase: 'Belum diverifikasi',
  NotYet: 'Belum',
  Off: 'Mati',
  Ok: 'Oke',
  OK: 'OKE',
  OkAllCaps: 'OKE',
  On: 'Pada',
  OnceOnlyAndWhenTermsAreUpdated: 'Hanya sekali dan ketika ketentuan diperbarui',
  OnEveryLogin: 'Setiap login',
  OnfirstLogin: 'Pada login pertama',
  OnlyEnabledUsersCanBeInvited: 'Hanya pengguna yang diaktifkan yang dapat diundang.',
  OnlyEnabledUsersCanBeInvitedSec2: 'Hanya orang dengan akses yang diaktifkan yang dapat diundang.',
  Optional: 'Opsional',
  Or: 'atau',
  OtherTeamMembers: '[size] anggota tim lainnya',
  Pending: 'Tertunda',
  PendingScorecards: 'Kartu skor yang tertunda',
  PeopleFormWarningText:
    "Menerapkan peran ruang 'Administrator' memberi orang akses tanpa batas. Mereka tidak dibatasi oleh pengaturan keamanan tim mereka",
  PeopleLowerCase: 'orang',
  PerDay: 'Per hari',
  Period: 'Periode',
  PerMonth: 'Per bulan',
  PersonHistory: 'Riwayat orang',
  PersonHistoryFor: 'Sejarah untuk',
  PersonLowerCase: 'orang',
  PerWeek: 'Per minggu',
  Phone: 'Telepon',
  PhoneNumber: 'nomor telepon',
  PhoneNumber_SentenceCase: 'Nomor telepon',
  PrintingAllowed: 'Pencetakan diizinkan',
  PrintingDenied: 'Pencetakan ditolak',
  Priority: 'Prioritas',
  PrivacyPolicy: 'Kebijakan Privasi',
  Profession: 'Profesi',
  Profile: 'Profil',
  Properties: 'Properti',
  ProvideBilling:'Berikan rincian penagihan Anda',
  ProvidePayment:'Berikan rincian pembayaran Anda',
  Qna: 'Tanya Jawab',
  QnaNotificationSwitchOff: 'Anda tidak akan menerima email apa pun',
  QnaNotificationSwitchOn: 'Anda akan segera menerima pembaruan',
  QnaRole: 'Peran Q&A',
  QnaRole_SentenceCase: 'Peran Q&A',
  QnaSubjects: 'Subjek Tanya Jawab',
  QnaSubjectSecurity: 'Tanya Jawab Subjek Keamanan',
  QnaSubmissionsLimit: 'Batasan pengiriman pertanyaan',
  QnaSubmissionsOnWeekends: 'Pengajuan pertanyaan pada akhir pekan',
  Ready: 'Siap',
  ReasonForRequest: 'Alasan permintaan',
  Recipients: 'Penerima',
  RecipientsOfEmailNote_Gen2:
    "Penerima email ini TIDAK akan dapat melihat alamat satu sama lain, jadi aman untuk mengirimkannya ke pengguna dari grup pengguna yang berbeda",
  Register: 'Daftar',
  RegisterYourInterest: 'Daftarkan minat Anda',
  RegisterYourInterest_SentenceCase:
    'Kirimkan permintaan ke Administrator <strong>[dataRoomName]</strong> untuk ditinjau. Jika pendaftaran Anda diterima, Anda akan diundang ke proyek tersebut.',
  Registration: 'Pendaftaran',
  Registration_LowerCase: 'pendaftaran',
  RegistrationDetails: 'Detail pendaftaran',
  RegistrationLinkDisabled: 'Tautan Registrasi Dinonaktifkan',
  RegistrationRequestSubmitted: 'Permintaan pendaftaran telah diajukan',
  Registrations: 'Registrasi',
  Registrations_LowerCase: 'pendaftaran',
  RegistrationTextCopy:
  'Anda telah mengizinkan tim penawar atau tamu untuk mendaftarkan minat. Salin tautan yang diberikan untuk mengizinkan orang mendaftar. Pendaftar baru akan muncul dalam daftar ini untuk Anda tinjau dan undang. Orang dalam daftar ini tidak memiliki akses hingga Anda mengundang dan menambahkan mereka ke tim.',
  Request: 'Meminta',
  RequestAccess: 'Minta Akses',
  RequestAccessDialogDescription: 'Berikan detail untuk orang yang memerlukan akses tambahan. Permintaan Anda akan ditinjau oleh Administrator.',
  RequestAccessDialogTitle: 'Permintaan akses tambahan',
  RequestAccessEmptyStateText: 'Pendaftar baru akan muncul dalam daftar ini untuk Anda tinjau. orang dalam daftar ini tidak memiliki akses hingga Administrator menambahkan mereka ke dalam tim.',
  RequestDetails: 'Minta detail',
  RequestorEmail: 'Email pemohon',
  Required: 'Diperlukan',
  ResendEmail: 'Kirim ulang email',
  ResendVerificationLink: 'Kirim ulang tautan verifikasi',
  Reset: 'Mengatur ulang',
  Review: 'Tinjauan',
  RoomRole_SentenceCase: 'Peran ruangan',
  RoomRoleAdminSubteamHelp: 'Administrator tidak dapat ditambahkan ke subtim.',
  RoomRoleHelp: "Peran Ruangan menentukan tingkat akses seseorang dalam ruangan tersebut.",
  Rooms: 'Kamar',
  RoomsAdvert1:
    "Dengan Dropbox Showcase, Anda dapat berbagi pekerjaan Anda dengan mitra dan klien dengan indah, melacak kemajuan dan mengawasi siapa yang melihat apa - semuanya di satu tempat.",
  RoomsAdvert2: 'Showcase tersedia untuk pengguna Dropbox Business Advanced dan Enterprise.',
  RoomsAdvertLink: 'Cari tahu lebih lanjut',
  RoomsAdvertTitle: 'Jalankan transaksi berkinerja tinggi',
  Saturday: 'Sabtu',
  Save: 'Menyimpan',
  SaveAndInvitePeople: 'Simpan dan undang orang',
  Saving: 'Penghematan',
  SavingAllowed: 'Menyimpan diperbolehkan',
  SavingDenied: 'Penyimpanan ditolak',
  SavingFailed: 'Penyimpanan gagal',
  Scorecards: 'Kartu skor',
  ScorecardsAdvert1:
    "Dengan Dropbox Showcase, Anda dapat berbagi pekerjaan Anda dengan mitra dan klien dengan indah, melacak kemajuan dan mengawasi siapa yang melihat apa - semuanya di satu tempat.",
  ScorecardsAdvert2: 'Showcase tersedia untuk pengguna Dropbox Business Advanced dan Enterprise.',
  ScorecardsAdvertLink: 'Cari tahu lebih lanjut',
  ScorecardsAdvertTitle: 'Jalankan transaksi berkinerja tinggi',
  Search: 'Mencari',
  Secure: 'Aman',
  SecureByDefault: 'Aman secara default',
  SecureOffice: 'Kantor aman',
  SecureOfficeText:
    'Secure Office melacak tampilan dan dapat menonaktifkan penyimpanan, penyalinan, dan pencetakan dalam file Microsoft Word, Excel, dan PowerPoint.',
  SecureOfficeTitle: 'Keamanan untuk dokumen Microsoft Office (Secure Office)',
  SecureOfficeWarning:
    'Secure Office tidak kompatibel dengan banyak perangkat umum, termasuk perangkat Apple iOS dan Android. Pengaturan ini mencegah orang yang tidak memiliki sistem yang kompatibel untuk dapat melihat berkas-berkas ini.',
  Security: 'Keamanan',
  SecurityControls: 'Kontrol keamanan',
  SecurityControlsOff: 'Kontrol keamanan mati',
  SecurityControlsOffDescription:
    'Jika kontrol keamanan dimatikan, penggunaan dokumen-dokumen ini tidak dibatasi setelah diunduh.',
  SecurityControlsOn: 'Kontrol keamanan aktif',
  SecurityControlsOnDescription:
    'Saat kontrol keamanan aktif, penggunaan dokumen Microsoft Office dan PDF dilacak. Salinan yang disimpan akan dinonaktifkan dari jarak jauh saat akses dicabut untuk tim atau saat Ruang dinonaktifkan.',
  SecurityControlsOnExtraDescription:
    'Anda juga dapat membatasi penyimpanan, pencetakan, pengeditan, dan penyalinan (pembatasan penyalinan hanya tersedia untuk dokumen Microsoft Office).',
  SecurityGroup_SentenceCase: 'Kelompok keamanan',
  SecurityPermissions: 'Izin keamanan',
  Select: 'Memilih',
  SelectPeople_SentenceCase: 'Pilih orang',
  SelectSubTeam: 'Silakan pilih Sub-tim.',
  SelectTeam: 'Silakan pilih Tim.',
  SelectUsers_SentenceCase: 'Pilih orang',
  SelectUserType: 'Silakan pilih peran ruangan.',
  SelfRegistrationHeader: 'Registrasi Mandiri',
  SelfRegistrationToolIntroDialogHeading:
    'Izinkan pengguna tamu untuk mendaftar',
  SelfRegistrationToolIntroDialogHelpLink:
    'Lihat Bantuan dan Dukungan pada Pendaftaran Penawar',
  SelfRegistrationToolIntroDialogTitle1:
    'Aktifkan pendaftaran pengguna tamu di menu tindakan pada halaman sisi Beli/Penawar.',
  SelfRegistrationToolIntroDialogTitle2:
    'Bagikan tautan yang disediakan di halaman web atau dalam email yang Anda buat.',
  SelfRegistrationToolIntroDialogTitle3:
    'Pengguna terdaftar dapat ditinjau dan diundang.',
  SellSide: 'Sisi Jual',
  SellSide_InviteHeading: 'Kirim undangan untuk menjual orang sampingan',
  SellSide_SentenceCase: 'Sisi Jual',
  Send: 'Mengirim',
  SendEmailInvitation: 'Kirim undangan email',
  SendEmailInvitations: 'Kirim undangan email',
  SendGuestInvitation:'Kirim undangan pengguna tamu',
  SendInvitationSubjectRequiredSentenceCase: 'Subjek diperlukan untuk email undangan',
  SendInvite_SentenceCase: 'Kirim undangan',
  SendInvites: 'Kirim undangan',
  SendInviteToSubscription: 'Undang ke langganan Anda',
  SendUpdates: 'Kirim pembaruan',
  SentAgo: 'Terkirim [time] lalu',
  SentDocumentChanged: 'Dikirim saat dokumen ditambahkan atau diubah',
  SessionTimeout: 'Waktu sesi habis',
  SetSecurityControls: 'Tetapkan kontrol keamanan',
  SetSecurityControlsBeforeAddingPeople: 'Tetapkan kontrol keamanan sebelum menambahkan orang.',
  SetSubmissionLimits: 'Tetapkan batas pengiriman',
  SetSubmissionLimitsDescription:
    'Batasi jumlah pertanyaan yang dapat diajukan tim per hari, minggu, atau bulan',
  ShouldBeEmailEmail: 'Email yang Anda masukkan bukan alamat email yang valid.',
  ShowActivityInReports_SentenceCase: 'Tampilkan aktivitas dalam laporan',
  ShowDetails: 'Tampilkan detail',
  ShowMore: 'Tampilkan lebih banyak',
  Status: 'Status',
  StayOnPage: 'Harap tetap berada di layar ini saat pengaturan sedang disalin',
  Subject: 'Subjek',
  Subject_Email_: 'Subjek',
  SubjectEmailHint: 'Subjek email adalah bidang yang wajib diisi',
  SubjectGroupNotSet: 'Kelompok subjek belum ditetapkan',
  SubmissionIndex: 'Indeks penyerahan',
  SubmissionIndexesSecurity: 'Indeks Pengajuan Keamanan',
  SubmissionIndexTopLevelFoldersSecurity: 'Folder tingkat atas Indeks Pengajuan Keamanan',
  Submissions: 'Pengajuan',
  SubTeam: 'Sub-tim',
  SubteamName: 'Nama sub-tim',
  SubTeamNameAlreadyExists: 'Sub-tim dengan nama yang sama sudah ada.',
  SubteamNameValidation: 'Nama sub-tim tidak boleh kosong',
  Success: 'Kesuksesan',
  Sunday: 'Minggu',
  SwitchTeam_Confirm: 'Ya, ganti tim',
  SwitchTeam_Title: 'Ganti tim',
  SwitchTeam_WarningMessage:
    'Sepertinya Anda telah membuat beberapa perubahan. Jika Anda keluar tanpa menyimpan, perubahan Anda akan hilang.',
  SydneyTime: 'Waktu Sydney',
  TalkToAnsaradaNow: 'Bicaralah dengan Ansarada sekarang',
  Team: 'Tim',
  TeamHistory: 'Sejarah tim',
  TeamHistoryFor: 'Sejarah Tim untuk',
  TeamMemberEmails: 'Email anggota tim',
  TeamMemberEmailsInfo: 'Email anggota tim Anda, dipisahkan dengan titik koma atau koma. Mereka semua akan diundang jika pendaftaran diterima.',
  TeamName: 'Nama tim',
  TeamNameAlreadyExists: 'Tim dengan nama yang sama sudah ada.',
  TeamNameValidation: 'Nama tim tidak boleh kosong',
  TeamPermissions: 'Izin tim',
  TenderFreemiumDialogBannerTitle:
    'Penagihan dimulai saat tamu pertama diundang.',
  TenderFreemiumDialogContent:
    'Kirim undangan ke tim penawar dan Anda dapat langsung memulai tahap pertama pengadaan. Anda dapat mengundang sebanyak mungkin penawar sesuai kebutuhan.',
  TenderFreemiumDialogSubContent:
    'Ansarada Sales akan menghubungi tim Anda dan membantu Anda melalui proses ini.',
  TermsAndConditions: 'syarat dan Ketentuan',
  TheSafestWayToEnterEmails:'Cara paling aman untuk memasukkan email adalah dengan menyalin dan menempel. Pastikan setiap alamat email dipisahkan dengan koma, titik koma, spasi, atau baris baru.',
  ThirdPartyIntegrations_SentenceCase: 'Integrasi Pihak Ketiga',
  ThirdPartyIntegrationsText:'Izinkan semua, beberapa, atau tidak ada integrasi pihak ketiga.',
  ThisSubTeamCannotAccess: 'Sub tim ini tidak dapat mengakses folder atau dokumen apa pun',
  ThisTeamCannotAccess: 'Tim ini tidak dapat mengakses folder atau dokumen apa pun',
  Thursday: 'Kamis',
  Time: 'waktu',
  TimePeriodAm: 'PAGI',
  TimePeriodPm: 'PM',
  To: 'Ke:',
  ToBeAbleToInvitePeopleToYourDataRoom:'untuk dapat mengundang orang ke ruang data Anda.',
  Today: 'Hari ini',
  ToInviteFirstGuestAndGoLive:'untuk mengundang pengguna tamu pertama Anda dan melakukan siaran langsung',
  Topic: 'Topik [topics]',
  Topics: 'Topik [topics',
  Total: 'Total',
  Translation_SentenceCase: 'Terjemahan',
  TranslationSettingText: 'Kami menggunakan AI untuk menerjemahkan dokumen secara langsung. Harap periksa terjemahan saat meninjau dokumen.',
  TranslationTitle: 'Terjemahkan konten dokumen menggunakan AI',
  Tuesday: 'Selasa',
  Unknown: 'Tidak dikenal',
  Up: 'Ke atas',
  Update: 'Memperbarui',
  UserCanLogInFromAnyIp: 'Pengguna ini dapat masuk dari alamat IP mana pun',
  UserCanLogInOnlyFromIpsBelow: 'Pengguna ini HANYA dapat masuk dari alamat IP yang ditentukan di bawah ini',
  UserExistsWithEmail: 'Pengguna ada dengan email [0]',
  UserGroup: 'Kelompok pengguna',
  UserInvitationLinkNote_Gen2:
    'Tag "[invitation_link]" diganti dengan hyperlink yang dibuat saat email dikirim. Tag ini harus ada di badan email.',
  UserInvitationLinkTagIsMissing:
    'Email undangan tidak dapat dikirim tanpa tautan akses. Salin [invitation_link] dengan tanda kurung dan tambahkan ke dalam pesan agar penerima dapat membuat akses mereka.',
  UserProperties: 'Properti Pengguna',
  UserStatus: 'Status pengguna',
  UserType: 'Tipe pengguna',
  UserTypeError: 'Peran ruangan diperlukan',
  UserUpdated: 'Orang berhasil diperbarui.',
  Verified: 'Terverifikasi',
  Verified_Users_: 'Terverifikasi',
  VerifyYourEmail:'Verifikasi email Anda',
  VerifyYourEmailAddressToInviteUsers: 'Verifikasi alamat email Anda untuk mengundang pengguna.',
  View: 'Melihat',
  ViewDetails: 'Lihat detailnya',
  ViewIndexAsGhost: 'Apa yang dapat mereka lihat?',
  ViewSecurity: 'Lihat keamanan',
  Warning: 'Peringatan',
  Watermark: 'Watermark',
  Wednesday: 'Rabu',
  Weekly: 'Mingguan',
  WeHaveSentTheVerificationLinkTo:"Kami telah mengirimkan tautan verifikasi ke [email]",
  Yes: 'Ya',
  YouCanAddDescriptionsAfterComma:
    'Anda juga dapat menambahkan deskripsi setelah koma, misalnya <b>1.1.1.1, IP kantor London</b>',
  YourCurrentIpAddress:
    '<b>Catatan:</b> Alamat IP Anda saat ini adalah [IP Address]. <a class="ace-link" [href]>Klik di sini</a> untuk menambahkannya ke dalam daftar.',
  YourCurrentIpAddressSec2: 'Tambahkan alamat IP Anda saat ini ke daftar putih.',
  YouWillReceiveAConfirmationInYourEmailAboutNextSteps:
    "Anda akan menerima konfirmasi di email tentang langkah selanjutnya.",
};
